//
// Accept cookies
//

( function($, waTheme) {

    var CookiesAlert = (function ($) {

        CookiesAlert = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options['$wrapper'];
            that.$toast = that.$wrapper.find('.toast');

            // VARS

            // DYNAMIC VARS

            // EVENTS
            that.bindEvents();
        };

        CookiesAlert.prototype.bindEvents = function () {
            var that = this;

            that.$toast.on('hidden.bs.toast', function () {
                $.cookie('acceptCookies', 'true', {expires: 365, path: '/'});
            });
        };

        return CookiesAlert;

    })($);

    waTheme.init.site.CookiesAlert = CookiesAlert;

    var $wrapper = $('.b-cookies-alert');
    if ($wrapper.length) {
        new window.waTheme.init.site.CookiesAlert({
            $wrapper: $wrapper,
        });
    }

})(jQuery, window.waTheme);
